module.exports = __webpack_public_path__ + "static/img/three.79b65a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gRDImg/three.png
// module id = FQ/4
// module chunks = 1